<template>
  <modal-brandme :show_modal="show_modal" size="md" @hidden="$emit('hidden')" :key="show_modal">
    <template #title>
      <h4 class="m-0 pl-1">{{ $t('creator.contactInfoTitle') }}</h4>
    </template>
    <template #body>
      <div v-if="loading" class="d-flex justify-content-center p-3">
        <b-spinner></b-spinner>
      </div>
      <b-alert v-else-if="has_error" variant="danger" class="p-1 m-1" show>{{ $t('creator.contactError') }}</b-alert>
      <div v-else class="px-1 pb-1" ref="contact_container">
        <h5 class="mb-1">{{ full_name }}</h5>

        <div class="contact-row">
          <div class="contact-icon"><feather-icon icon="MailIcon" size="16"></feather-icon></div>
          <div class="flex-grow-1 overflow-hidden">
            <small class="text-muted d-block">{{ $t('creator.contactInfoEmail') }}</small>
            <a v-if="contact.email" :href="`mailto:${contact.email}`" class="contact-value">{{ contact.email }}</a>
            <span v-else class="text-muted">{{ $t('creator.contactNoData') }}</span>
          </div>
          <feather-icon v-if="contact.email" icon="CopyIcon" class="copy-icon-contact" size="28" @click="copyAction(contact.email)"></feather-icon>
        </div>

        <div class="contact-row">
          <div class="contact-icon"><feather-icon icon="PhoneIcon" size="16"></feather-icon></div>
          <div class="flex-grow-1 overflow-hidden">
            <small class="text-muted d-block">{{ $t('creator.contactPhone') }}</small>
            <a v-if="contact.telephone" :href="`tel:${contact.telephone.replace(/\s/g, '')}`" class="contact-value">{{ contact.telephone }}</a>
            <span v-else class="text-muted">{{ $t('creator.contactNoData') }}</span>
          </div>
          <feather-icon v-if="contact.telephone" icon="CopyIcon" class="copy-icon-contact" size="28" @click="copyAction(contact.telephone)"></feather-icon>
        </div>

        <div v-if="networks.length > 0" class="mt-2">
          <h6 class="mb-1">{{ $t('creator.contactNetworks') }}</h6>
          <vue-perfect-scrollbar :settings="{ maxScrollbarLength: 60 }" class="scroll-area-contact-networks">
            <div v-for="(network, index) in networks" :key="index" class="contact-network">
              <b-avatar variant="ligth" size="30px">
                <b-img :src="getIconWhite(network.network)" :class="getIconColor(network.network)" fluid></b-img>
              </b-avatar>
              <div class="ml-1 overflow-hidden">
                <p class="m-0 contact-value" :title="network.username">{{ network.username }}</p>
                <small class="text-muted">{{ nameNetworks(network.network, false) }} · {{ getFormat(network.followers) }} {{ $t('creator.contactFollowers') }}</small>
              </div>
            </div>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </template>
  </modal-brandme>
</template>

<script>
import { BAlert, BAvatar, BImg, BSpinner } from 'bootstrap-vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import pitch_service from '@/services/pitch_service';
import { getIconWhite, getIconColor } from '@/libs/utils/icons';
import { getFormat, nameNetworks } from '@/libs/utils/formats';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  name: 'modalContactInfo',
  components: {
    BAlert,
    BAvatar,
    BImg,
    BSpinner,
    VuePerfectScrollbar,
    modalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
  },
  props: {
    show_modal: {
      type: Boolean,
      required: true
    },
    user_id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      getIconWhite,
      getIconColor,
      getFormat,
      nameNetworks,
      loading: true,
      has_error: false,
      contact: {},
    }
  },
  computed: {
    full_name() {
      return `${this.contact.first_name || ''} ${this.contact.last_name || ''}`.trim();
    },
    networks() {
      return [...(this.contact.networks || [])].sort((a, b) => b.followers - a.followers);
    }
  },
  created() {
    this.getContactInfo();
  },
  methods: {
    getContactInfo() {
      this.loading = true;
      this.has_error = false;
      pitch_service.getContactInfo(this.user_id).then((response) => {
        // En error el servicio regresa el response de axios (con status numérico)
        if (!response || typeof response.status === 'number') this.has_error = true;
        else this.contact = response;
        this.loading = false;
      });
    },
    copyAction(text) {
      // El contenedor debe estar dentro del modal, si no el focus trap de b-modal impide copiar
      this.$copyText(text, this.$refs.contact_container).then(() => {
        loadToastificationContent().then((component) => {
          this.$toast({
            component: component.default,
            position: 'top-right',
            props: {
              title: this.$t('campaigns.copied'),
              icon: 'CopyIcon',
              text: this.$t('creator.contactCopied'),
              variant: 'success'
            }
          })
        })
      });
    },
  }
}
</script>

<style scoped>
.contact-row {
  display: flex;
  align-items: center;
  padding: 0.7em 0;
  border-bottom: 1px solid #eff3f6;
}
.contact-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background-color: #f2f2f2;
  margin-right: 0.8em;
}
.contact-value {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.copy-icon-contact {
  min-width: 28px;
  background-color: #f2f2f2;
  color: #b5b5b5;
  border-radius: 10px;
  cursor: pointer;
  padding: 6px;
  margin-left: 0.5em;
}
.copy-icon-contact:hover {
  background-color: #E0F1F6;
  color: #6DAECA;
}
.scroll-area-contact-networks {
  max-height: 280px;
}
.contact-network {
  display: flex;
  align-items: center;
  padding: 0.4em 0;
}
</style>
